import { render, staticRenderFns } from "./ObservacionesCuota.vue?vue&type=template&id=3da3574e&"
import script from "./ObservacionesCuota.vue?vue&type=script&lang=js&"
export * from "./ObservacionesCuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports